import { useCallback } from "react";
import { useMutation } from "@apollo/client/react";

import { ResolveAddressSuggestionDocument } from "#app/lib/data";

/** Resolve an ephemeral Google Places suggestion to its canonical address. */
export function useResolveAddressSuggestion() {
  const [resolveAddressMutation] = useMutation(
    ResolveAddressSuggestionDocument,
  );

  return useCallback(
    async (placeId: string, description: string) => {
      const { data } = await resolveAddressMutation({
        variables: { placeId, description },
      });
      return data?.resolveAddressSuggestion ?? null;
    },
    [resolveAddressMutation],
  );
}
